import {RedeemInfoList} from '../type';

const REDEEM_INFO_LIST: RedeemInfoList = [
  {
    title: 'more_coupon_register_guide_title',
    texts: [
      'more_coupon_register_guide_1',
      'more_coupon_register_guide_2',
      'more_coupon_register_guide_3',
    ],
  },
  {
    title: 'more_coupon_register_event_guide_title',
    texts: [
      'more_coupon_register_event_guide_1',
      'more_coupon_register_event_guide_2',
      'more_coupon_register_event_guide_3',
    ],
  },
  {
    title: 'more_coupon_register_paid_guide_title',
    texts: [], // isGlobal 에 따라 getRedeemInfoList()에서 동적으로 처리됩니다.
  },
];

export function getRedeemInfoList(isGlobal: boolean): RedeemInfoList {
  return REDEEM_INFO_LIST.map(item => {
    // 유료 쿠폰 가이드 항목만 분기 처리
    if (item.title === 'more_coupon_register_paid_guide_title') {
      return {
        ...item,
        texts: isGlobal
          ? [
              'more_coupon_register_paid_guide_1_global',
              'more_coupon_register_paid_guide_2',
            ]
          : [
              'more_coupon_register_paid_guide_1_kor',
              'more_coupon_register_paid_guide_2_kor',
            ],
      };
    }
    // 나머지 항목들은 그대로 반환
    return item;
  });
}
